import { render } from "./MainUserAssists.vue?vue&type=template&id=1eaf8471&scoped=true"
import script from "./MainUserAssists.vue?vue&type=script&lang=js"
export * from "./MainUserAssists.vue?vue&type=script&lang=js"

import "./MainUserAssists.vue?vue&type=style&index=0&id=1eaf8471&scoped=true&lang=css"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eaf8471"]])

export default __exports__